<div class="estimated-value">
  <div class="estimated-value__has-estimated-value" *ngIf="listing.hasHomeEstimate">
      <div class="estimated-value__estimated-value-container" *ngIf="isAuthenticated || isAllowed">
          <div class="estimated-value__estimated-value" *ngIf="!retrievingEstimate">
            {{ estimateRangeLow }} - {{ estimateRangeHigh }}
          </div>
          <div class="estimated-value__estimated-value-loader" *ngIf="retrievingEstimate">
            {{ 'listing-summary.retreiving-estimate' | translate }}
          </div>
      </div>
      <div class="estimated-value__login-to-view" *ngIf="!isAuthenticated && !isAllowed">
        {{ (isMobile ? 'listing-summary.home-worth-mobile' : 'listing-summary.home-worth') | translate }}
        <a class="estimated-value__login-text" (click)="loginToView()">
          {{ 'listing-summary.log-in' | translate }}
        </a>
      </div >
  </div>
  <p class="estimated-value__no-estimated-value"  *ngIf="!listing.hasHomeEstimate">
    {{ 'listing-summary.not-avaliable' | translate }}
  </p>
</div>
